// noinspection DuplicatedCode

import React, { useCallback, useEffect, useRef, useState } from "react";
import { Select, Space } from "antd";
import Styles from "./Styles";
import SearchArea from "../../components/moleculas/SearchArea";
import {
  apiGetDeviceStat,
  apiGetDeviceStatCam,
  apiGetEvent,
  apiGetEventAction,
  apiGetEquipment,
  apiGetMasterCode,
  apiGetServiceCode,
  apiGetSitesComp,
  apiGetSvcEqui,
} from "../../api/api";
import { Option } from "antd/es/mentions";
import {
  getGlobalSessionParam,
  getSessionParam,
  isEmpty,
  setGlobalSessionParam,
  setSessionParam,
} from "../../utils/comm";
import "./Home.css";
import moment from "moment";
import PopDeviceStatus from "./PopDeviceStatus";
import PopEventStatus from "./PopEventStatus";
import Modal from "antd/es/modal/Modal";
import { useMqtt } from "../../context/MqttContext";

function Home() {
  // s: 전역변수
  // static final 변수
  // 초기화 코드
  const InitCode = {
    EVT: "EVT",
    DEV: "DEV",
    DST: "DST",
    SITE: "SITE",
    SVC: "SVC",
    MAP: "MAP",
  };
  // Marker 상태 코드 (삭제의 경우 데이터 누적 방지를 위해 데이터 자체를 즉시 삭제)
  const MarkerStatusCode = {
    NEW: "NEW",
    UPDATE: "UPDATE",
    DELETE: "DELETE",
  };

  // 환경 데이터 초기화 여부
  const [initFlag, setInitFlag] = useState(
    new Map([
      [InitCode.EVT, false], // 이벤트 코드 초기화 여부
      [InitCode.DEV, false], // 디바이스 형태 코드 초기화 여부
      [InitCode.DST, false], // 디바이스 상태 코드 초기화 여부
      [InitCode.SITE, false], // 사이트 목록
      [InitCode.SVC, false], // 서비스 목록
      [InitCode.MAP, false], // 지도 초기화 여부
    ])
  );

  // 마스터 코드 데이터
  const [code, setCode] = useState(new Map());

  // 기본값
  const [defaultValue] = useState({
    siteId: !isEmpty(getGlobalSessionParam("siteId")) ? getGlobalSessionParam("siteId") : null,
    svcCd: !isEmpty(getGlobalSessionParam("svcCd")) ? getGlobalSessionParam("svcCd") : null,
  });

  // 사이트 & 서비스 선택 값
  const [formData, setFormData] = useState({
    siteId: null,
    svcCd: null,
  });
  // 사이트 목록
  const [sitesData, setSitesData] = useState([]);
  // 서비스 목록
  const [serviceData, setServiceData] = useState([]);
  // 이벤트 목록
  const [eventData, setEventData] = useState([]);
  // 굴착기 및 디바이스 데이터를 조합한 마커 목록
  const [markerData, setMarkerData] = useState(new Map());
  let prevMarkerData = useRef(new Map());
  // 상황 미디어 정보
  const [statusMediaData, setStatusMediaData] = useState([
    {
      serialNo: null,
      znNm: null,
      updateDt: null,
      fileNm: null,
    },
  ]);
  // 이벤트 미디어 정보
  const [eventMediaData, setEventMediaData] = useState([{ serialNo: null, znNm: null, updateDt: null, fileNm: null }]);
  // 상황 모달
  const [isStatusModalVisible, setStatusModalVisible] = useState(false);
  // 이벤트 모달
  const [isEventModalVisible, setEventModalVisible] = useState(false);
  // 새로고침 딜레이
  const [delayMs] = useState(60 * 1000); // 1분
  // 지도
  const [map, setMap] = useState();
  // 서비스 별 장비 목록
  const [svcEquiList, setSvcEquiList] = useState([]);
  const { lastEvent, eventModalVisible, eventInfo, closeEventModal } = useMqtt();

  var customBackhoeControl = new window.naver.maps.CustomControl();
  // e: 전역변수

  // s: function

  // 각 process 별 초기화 완료 여부
  function completeInit(code) {
    setInitFlag((prev) => new Map(prev).set(code, true));
  }

  // 초기화 완료 여부
  function checkInitFlag() {
    let result = true;
    initFlag.forEach((flag) => {
      result &= flag;
    });

    return result;
  }

  // 지도 업데이트 가능 여부
  function checkMapUpdateFlag() {
    return checkInitFlag() && formData && !isEmpty(formData.siteId) && !isEmpty(formData.svcCd);
  }

  function getMqttEquDisplay(equSn, equNo) {
    if (isEmpty(equSn)) {
      return "";
    }
    if (isEmpty(equNo)) {
      return equSn;
    }
    return equSn + "(" + equNo + ")";
  }

  function formatElapsedMmSs(startTime) {
    if (!startTime) {
      return "00:00";
    }

    const elapsedSec = Math.max(0, Math.floor((Date.now() - new Date(startTime).getTime()) / 1000));
    const minutes = Math.floor(elapsedSec / 60);
    const seconds = elapsedSec % 60;

    return String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0");
  }

  function buildMqttEventPopupHtml(info, elapsedTime = "00:00") {
    const equDisplay = getMqttEquDisplay(info.equSn, info.equNo);

    return (
      '<div class="map-mqtt-event-popup-zone">' +
      '  <div class="map-mqtt-event-popup-header">' +
      '    <span class="map-mqtt-event-popup-title">이벤트 발생</span>' +
      '    <img class="mqttEventPopupCloseBtn" src="/images/close_btn.png" alt="닫기" />' +
      "  </div>" +
      '  <div class="map-mqtt-event-popup-body">' +
      '    <div class="map-mqtt-event-popup-row"><span>발생 일시</span><span>' +
      (info.updateDt || "") +
      "</span></div>" +
      '    <div class="map-mqtt-event-popup-row"><span>장비 ID</span><span>' +
      equDisplay +
      "</span></div>" +
      '    <div class="map-mqtt-event-popup-row"><span>감지 이벤트</span><span>' +
      (info.evtNm || "") +
      "</span></div>" +
      '    <div class="map-mqtt-event-popup-elapsed">' +
      '      <span class="map-mqtt-event-popup-elapsed-label">경과시간</span>' +
      '      <span id="mqttEventElapsedTime" class="map-mqtt-event-popup-elapsed-time">' +
      elapsedTime +
      "</span>" +
      "    </div><div class='map-mqtt-event-popup-footer mqttEventPopupCloseBtn'>" +
      '      <span class="map-mqtt-event-popup-elapsed-label">닫기</span>' +
      "   </div>" +
      "  </div>" +
      "</div>"
    );
  }

  // 사업장 변경 이벤트
  function changeSite(value, item) {
    setGlobalSessionParam({
      siteId: item ? value : null,
      svcCd: null,
    });
    setFormData({ ...formData, ["siteId"]: value });
  }

  // 서비스 변경 이벤트
  function changeSvc(value, item) {
    setGlobalSessionParam({
      siteId: getGlobalSessionParam("siteId"),
      svcCd: item ? value : null,
    });

    setFormData({ ...formData, ["svcCd"]: item ? value : null });
  }

  useEffect(() => {
    let equiLabel = document.getElementsByClassName("equiLabel")
    if(equiLabel.length > 0) {
      for(let i = 0; i < equiLabel.length; i++){
        equiLabel[i].remove();
      }
    }
    
    if(svcEquiList.length > 0){
      const svcEquipmentHtml =
        '<div style="margin-top: 24px; margin-left: 24px; display: flex;" class="equiLabel">' +
        '   <div style="box-sizing: border-box; display: flex; flex-direction: row; align-items: flex-start; padding: 9px 16px; gap: 20px; height: 42px; left: 264px; top: 162px; background: #FFFFFF; border: 1px solid #E9ECF1; box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08); border-radius: 10px;">' +
            (svcEquiList.includes('EQU00010') ? '<img id="imgBackhoeIcon" src="/images/icon_excavator_blue_24.png" alt="굴착기 아이콘" title="굴착기" />' : '') +
            (svcEquiList.includes('EQU00020') ? '<img id="imgRollerIcon" src="/images/icon_roller_blue_24.png" alt="롤러 아이콘" title="롤러" />' : '') +
            (svcEquiList.includes('EQU00030') ? '<img id="imgDozereIcon" src="/images/icon_dozer_blue_24.png" alt="도저 아이콘" title="도저" />' : '') +
            (svcEquiList.includes('EQU00040') ? '<img id="imgSprinklerIcon" src="/images/icon_sprinkler_blue_24.png" alt="살수차 아이콘" title="살수차" />' : '') +
            (svcEquiList.includes('EQU00050') ? '<img id="imgDumptruckIcon" src="/images/icon_dump truck_blue_24.png" alt="덤프 아이콘" title="덤프" />' : '') +
            (svcEquiList.includes('EQU00060') ? '<img id="imgForkliftruckIcon" src="/images/icon_forklift_blue_24.png" alt="지게차 아이콘" title="지게차" />' : '') +
            (svcEquiList.includes('EQU00070') ? '<img id="imgSafetyIcon" src="/images/icon_safety_blue_24.png" alt="안전관리 장비 아이콘" title="안전관리 장비" />' : '') +
            (svcEquiList.includes('EQU00080') ? '<img id="imgVisionIcon" src="/images/icon_vision_blue_24.png" alt="비전 아이콘" title="비전" />' : '') +
        '   </div>' +
        '   <div style="margin- left: 8px; box-sizing: border-box; display: flex; flex-direction: row; align-items: center; padding: 9px 16px; height: 42px; background: #FFFFFF; border: 1px solid #E9ECF1; box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08); border-radius: 10px;">' +
        '     <img id="openEquipmentLegend" src="/images/icon_chevron-right_black_16.png" alt="장비 범례 열기" style="cursor: pointer;" />' +
        '     <div id="equipmentLegend" style="display: none; flex-direction: row; align-items: center; cursor: default;" >' + 
        '       <div style="box-sizing: border-box; display: flex; flex-direction: row; align-items: center; padding: 9px 0px; gap: 10px; height: 42px; background: #FFFFFF;">' +
        '         <div style="width: 12px; height: 12px; border-radius: 50%; background-color: #939AA0;"></div>' +
        '         <span style="font-weight: bold; color: #5E6675; margin-right: 8px;">작업전</span>' +
        '         <div style="width: 12px; height: 12px; border-radius: 50%; background-color: #00B050;"></div>' +
        '         <span style="font-weight: bold; color: #5E6675; margin-right: 8px;">작업진행중</span>' +
        '         <div style="width: 12px; height: 12px; border-radius: 50%; background-color: #FF9C5B;"></div>' +
        '         <span style="font-weight: bold; color: #5E6675;">작업대기</span>' +
        '       </div>' +
        '       <img id="closeEquipmentLegend" src="/images/icon_chevron-left_black_16.png" alt="장비 범례 닫기" style="margin-left: 16px; cursor: pointer;" />' +
        '     </div>' +
        '   </div>' +
        '</div>';
  
      customBackhoeControl = new window.naver.maps.CustomControl(svcEquipmentHtml, {
        position: window.naver.maps.Position.TOP_LEFT,
      });
      customBackhoeControl.setMap(map)

      const openEquipmentLegend = document.getElementById("openEquipmentLegend");
      const equipmentLegend = document.getElementById("equipmentLegend");
      const closeEquipmentLegend = document.getElementById("closeEquipmentLegend");
      openEquipmentLegend.onclick = function(){
        openEquipmentLegend.style.display = 'none';
        equipmentLegend.style.display = 'flex';
      } 
      closeEquipmentLegend.onclick = function(){
        openEquipmentLegend.style.display = 'flex';
        equipmentLegend.style.display = 'none';
      }
    }
  }, [svcEquiList]);
  // 마스터 코드 조회
  async function callEvtCode(code) {
    const model = {
      catCd: code,
    };

    try {
      const response = await apiGetMasterCode(model);

      if (response.data.code === 0) {
        pushCodeData(code, response.data.data);
      } else {
        pushCodeData(code, []);
      }
    } catch (e) {
      pushCodeData(code, []);
    } finally {
      completeInit(code);
    }
  }

  // 코드명 조회
  function getCodeNm(cd, key) {
    let value = "";
    if (key != null) {
      code.get(cd).forEach((item) => {
        if (item.code === key) {
          value = item.codeNm;
        }
      });
    }
    return value;
  }

  // 사업장 목록 조회
  async function callSites() {
    const model = {
      compId: sessionStorage.getItem("compId"),
      userId: sessionStorage.getItem("userId"),
    };

    try {
      const response = await apiGetSitesComp(model);

      if (response.data.code === 0) {
        setSitesData([...response.data.data]);
      } else {
        setSitesData([]);
      }
    } catch (e) {
      setSitesData([]);
    } finally {
      if (!initFlag.get(InitCode.SITE)) {
        completeInit(InitCode.SITE);
        setFormData({ ...formData, ["siteId"]: defaultValue.siteId });
        if (defaultValue.svcCd === null) {
          completeInit(InitCode.SVC);
        }
      }
    }
  }

  // 마스터 코드 데이터 추가
  function pushCodeData(initCode, data) {
    setCode((prev) => new Map(prev).set(initCode, data));
  }

  // 지도 초기화
  function initMap() {
    // s: 지도 생성
    // 지도 라이브러리 및 지도를 생성할 요소여부 체크
    if (!window.naver) return;

    // 지도 옵션
    const mapOptions = {
      useStyleMap: true,
      // center: new window.naver.maps.LatLng(37.3614483, 127.1114883),
      mapTypeId: window.naver.maps.MapTypeId.NORMAL,
      mapTypeControl: false,
      mapTypeControlOptions: {
        style: window.naver.maps.MapTypeControlStyle.BUTTON,
        position: window.naver.maps.Position.TOP_LEFT,
      },
      zoomControl: true,
      zoomControlOptions: {
        style: window.naver.maps.ZoomControlStyle.SMALL,
        position: window.naver.maps.Position.LEFT_CENTER,
      },
      scaleControl: false,
      scaleControlOptions: {
        position: window.naver.maps.Position.BOTTOM_CENTER,
      },
      logoControl: true,
      logoControlOptions: {
        position: window.naver.maps.Position.BOTTOM_LEFT,
      },
      mapDataControl: true,
      mapDataControlOptions: {
        position: window.naver.maps.Position.BOTTOM_LEFT,
      },
    };

    //지도 생성
    const map = new window.naver.maps.Map("map-wrap", mapOptions);
    // setMapEl(map);    

    // 이벤트 리스트 표시 버튼 html
    const showButtonHtml =
      '<button id="slideShowBtn" class="map-evt-slide-btn" style="display: none;">' +
      '   <img src="/images/btn_panel_show.png" alt="목록 보이기 버튼">' +
      "</button>";

    // 이벤트 리스트 html
    let eventListHtml =
      '<div id="map-top-right-controls" class="map-top-right-controls">' +
      '  <div id="map-mqtt-event-popup" class="map-mqtt-event-popup" style="display: none;"></div>' +
      '  <div id="map-evt-list">\n' +
      '   <button id="slideHideBtn" class="map-evt-slide-btn"><img src="/images/btn_panel_hide.png" alt="목록 숨김버튼"></button>' +
      '   <div class="map-evt-list-zone">' +
      '       <div class="map-evt-list-title">감지 이벤트 리스트</div>' +
      '       <div class="map-evt-list-data">' +
      '           <div class="map-evt-list-data-header">' +
      '               <table class="map-evt-list-tab">' +
      "                   <thead>" +
      '                       <tr style="border-bottom: 1px solid #E9ECF1; height: 36px">' +
      '                           <td style="width:90px; text-align: left;">일시</td>' +
      '                           <td style="width:60px; text-align: center;">장비ID</td>' +
      '                           <td style="width:120px; text-align: right;">감지 이벤트</td>' +
      "                       </tr>" +
      "                   </thead>" +
      "               </table>" +
      "           </div>" +
      '           <div id="eventDataListZone" class="map-evt-list-data-content">' +
      '               <table class="map-evt-list-tab">' +
      '                   <tbody id="eventDataList">' +
      "                   </tbody>" +
      "               </table>" +
      "           </div>" +
      "       </div>" +
      "   </div>" +
      "</div>" +
      "</div>";

    // 지도 초기화 이후
    window.naver.maps.Event.once(map, "init", function () {
      // 사용자 지정 컨트롤 생성    
      let showButtonControl = new window.naver.maps.CustomControl(showButtonHtml, {
        position: window.naver.maps.Position.RIGHT_CENTER,
      });
      let customControl = new window.naver.maps.CustomControl(eventListHtml, {
        position: window.naver.maps.Position.TOP_RIGHT,
      });

      // 사용자 지정 컨트롤을 맵에 연동
      showButtonControl.setMap(map);
      // customBackhoeControl.setMap(map);
      // 우측 이벤트 목록 (반드시 범례 부분 보다 뒤에 setMap 해야 z-index 가 더 높아져서 가려지지 않음)
      customControl.setMap(map);

      // s: 이벤트 등록
      // 데이터 목록 높이 및 스크롤
      const eventDataListZone = document.getElementById("eventDataListZone");
      const mapContainer = document.getElementById("map-container");

      const offsetHeight = 152; //68;
      eventDataListZone.style.height = mapContainer.clientHeight - offsetHeight + "px";

      window.addEventListener("resize", function () {
        eventDataListZone.style.height = mapContainer.clientHeight - offsetHeight + "px";
      });

      // 감지 이벤트 목록 숨김&표시 버튼
      const slideShowBtn = document.getElementById("slideShowBtn");
      const slideHideBtn = document.getElementById("slideHideBtn");
      const mapEvtList = document.getElementById("map-evt-list");
      const mapTopRightControls = document.getElementById("map-top-right-controls");
      slideShowBtn.addEventListener("click", function () {
        slideShowBtn.style.display = "none";
        mapEvtList.style.display = "flex";
        mapTopRightControls.classList.remove("map-top-right-controls--list-hidden");
      });

      slideHideBtn.addEventListener("click", function () {
        slideShowBtn.style.display = "block";
        mapEvtList.style.display = "none";
        mapTopRightControls.classList.add("map-top-right-controls--list-hidden");
      });
      // e: 이벤트 등록
      setMap(map);
    });

    // e: 지도 생성
  }

  // 주기적 반복함수 useInterval 정의
  function useInterval(callback, delay) {
    const savedCallback = useRef();
    const intervalRef = useRef(null);

    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }

      if (delay !== null) {
        let id = setInterval(tick, delay);
        intervalRef.current = id;
        return () => clearInterval(id);
      }
    }, [delay]);

    // clear interval on when component gets removed to avoid memory leaks
    useEffect(() => {
      return () => clearInterval(intervalRef.current);
    }, []);

    const reset = useCallback(() => {
      if (intervalRef.current !== null) {
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(savedCallback.current, delay);
      }
    });

    const stop = useCallback(() => {
      if (intervalRef.current !== null) {
        clearInterval(intervalRef.current);
      }
    });

    return {
      reset,
      stop,
    };
  }

  // 자동 새로고침 기능
  // reset: 자동 새로고침 기능 재실행 - Delay 처음 부터
  // stop: 자동 새로고침 중지
  const { reset, stop } = useInterval(
    () => {
      // 초기화 완료 및 선택 데이터가 있는 경우 반복 실행
      if (checkMapUpdateFlag()) {
        changeSvcView(false).then();
      } else {
        stop();
      }
    },
    delayMs,
    false
  );

  // 장비 목록 조회
  async function callExcavatorList() {
    const model = {
      siteId: formData.siteId,
      svcCdList: formData.svcCd,
    };

    let result = [];

    try {
      const response = await apiGetEquipment(model);

      if (response.data.code === 0) {
        result = [...response.data.data];
      }
    } catch (ignore) {}

    return result;
  }

  // 디바이스 목록 조회
  async function callDeviceList() {
    const model = {
      siteId: formData.siteId,
      svcCdList: formData.svcCd,
    };

    let result = [];
    try {
      const response = await apiGetDeviceStat(model);

      if (response.data.code === 0) {
        result = response.data.data;
      }
    } catch (ignore) {}

    return result;
  }

  // 이벤트 목록 조회
  async function callEventList() {
    const model = {
      siteId: formData.siteId,
      svcCdList: formData.svcCd,
      startDt: moment().format("YYYY-MM-DD"),
      endDt: moment().format("YYYY-MM-DD"),
    };

    try {
      const response = await apiGetEvent(model);
      if (response.data.code === 0 || response.data.code === 10) {
        if (isEmpty(response.data.data)) {
          setEventData([]);
        } else {
          response.data.data.sort((a, b) => {
            return moment.utc(b.createDt).diff(moment.utc(a.createDt));
          });
          setEventData(response.data.data);
        }
      }
    } catch (e) {
      setEventData([]);
    }
  }

  // 디바이스 카메라 조회
  async function callDeviceStat(devId) {
    const model = {
      siteId: sessionStorage.getItem("siteId"),
      devId: devId,
    };

    try {
      const response = await apiGetDeviceStatCam(model);

      if (response.data.code === 0 || response.data.code === 10) {
        if (isEmpty(response.data.data)) {
          return [];
        } else {
          return response.data.data;
        }
      }
    } catch (e) {
      return [];
    }
  }

  // 이벤트 상황 목록 조회
  async function callEventActionList(evtId) {
    const model = {
      siteId: sessionStorage.getItem("siteId"),
      evtId: evtId,
    };

    try {
      const response = await apiGetEventAction(model);
      if (response.data.code === 0 || response.data.code === 10) {
        if (isEmpty(response.data.data)) {
          return [];
        } else {
          return response.data.data;
        }
      }
    } catch (e) {
      return [];
    }
  }

  // 굴착기와 디바이스 데이터를 받아 마커정보 갱신
  function updateMarkerData(excavatorData, deviceData, updateBoundsFlag) {
    let newMarkerData = new Map(); // 신규 마커 데이터

    try {
      if (prevMarkerData.current != null && prevMarkerData.current.size > 0) {
        // 삭제 상태로 일괄 변경: 데이터 비교 하여 신규 및 수정항목이 되지 않으면 삭제 처리
        prevMarkerData.current.forEach((data, devId) => {
          newMarkerData.set(devId, Object.assign(data, { markerFlag: MarkerStatusCode.DELETE }));
        });
      }

      // 데이터 목록을 merge 하기 위해 각각 devId를 key 값으로 하는 Map 생성
      let mergeMap = new Map(); // 합처진 Map
      let excavatorMap = new Map(); // 굴착기 데이터 Map
      let deviceMap = new Map(); // 디바이스 Map

      // 굴착기 Map 데이터 입력
      if (excavatorData != null && excavatorData.length > 0) {
        for (let i = 0; i < excavatorData.length; i++) {
          const _data = excavatorData[i];
          const _devId = _data.aiDevId; // 디바이스 ID (key)
          const _delYn = _data.delYn; // 삭제여부

          if (_delYn === "N") {
            const _excId = _data.devId; // 굴착기 ID
            const _workSt = _data.workSt; // 작업상태
            const _workStIco = getWksIcon(_workSt, _data.devTp); // 작업상태 아이콘
            const _gpsLat = _data.gpsLat; // 위도
            const _gpsLong = _data.gpsLong; // 경도
            const _devSn = _data.devSn; // 장비 시리얼 번호 (화면의 장비 ID에 대체 표시)
            const _devNo = _data.devNo; // 장비 번호 (화면의 장비 ID에 대체 표시)
            const _devModel = _data.devModel; // 모델
            const _devOrg = _data.devOrg; // 소속
            const _user = _data.user; // 기사
            const _tel = _data.tel; // 연락처

            if (_excId && _workStIco && _gpsLat && _gpsLong && _devSn && _devNo) {
              // 예외처리
              const sourceData = {
                devId: _devId,
                excId: _excId,
                workSt: _workSt,
                workStIco: _workStIco,
                devTp: _data.devTp,
                delYn: _delYn,
                gpsLat: _gpsLat,
                gpsLong: _gpsLong,
                devSn: _devSn,
                devNo: _devNo,
                devModel: _devModel,
                devOrg: _devOrg,
                user: _user,
                tel: _tel,
              };
              excavatorMap.set(_devId, sourceData);
            }
          }
        }
      }

      // 디바이스 Map 데이터 입력
      if (deviceData != null && deviceData.length > 0) {
        for (let i = 0; i < deviceData.length; i++) {
          const _data = deviceData[i];
          const _devId = _data.devId; // 디바이스 ID (key)
          const _serialNo = _data.serialNo; // 디바이스 ID (key)
          const _devTp = _data.devTp; // 디바이스 유형 코드
          const _devTpNm = getCodeNm(InitCode.DEV, _devTp); // 디바이스 유형
          const _statCd = _data.statCd; // 디바이스 상태 코드
          const _statCdNm = getCodeNm(InitCode.DST, _statCd); // 디바이스 상태 코드명
          const _cpuTemp = isNaN(_data.cpuTemp) ? "-" : _data.cpuTemp; // cpu 온도
          const _cpuTempUnit = _cpuTemp + "˚C"; // cpu 온도 + 단위

          const sourceData = {
            devId: _devId,
            serialNo: _serialNo,
            devTpNm: _devTpNm,
            statCd: _statCd,
            statCdNm: _statCdNm,
            cpuTempUnit: _cpuTempUnit,
            markerFlag: prevMarkerData.current.has(_devId) ? MarkerStatusCode.UPDATE : MarkerStatusCode.NEW,
          };
          deviceMap.set(_devId, sourceData);
        }
      }

      // 굴착기 Map 과 디바이스 Map 합치기
      // 위경도 정보가 있는 굴착기 Map 을 기준으로 합침
      if (excavatorMap.size > 0) {
        excavatorMap.forEach((excavator, key) => {
          let merged = excavator;
          if (deviceMap.has(key)) {
            merged = Object.assign({}, excavator, deviceMap.get(key));
          }
          // 디바이스 통신해지(DST00020)상태인 경우 작업전(WKS00010) 아이콘으로 표시
          if (merged.statCd === "DST00020") {
            const idleIcon = getWksIcon("WKS00010", merged.devTp);
            if (idleIcon) {
              merged.workStIco = idleIcon;
            }
          }
          mergeMap.set(key, merged);
        });
      }

      // 통합된 데이터로 이전 데이터와 비교하여 신규/갱신/삭제 여부를 결정
      if (mergeMap.size > 0) {
        mergeMap.forEach((data, key) => {
          const _devId = data.devId;
          const markerStatusCode = prevMarkerData.current.has(_devId) ? MarkerStatusCode.UPDATE : MarkerStatusCode.NEW;

          if (prevMarkerData.current.has(_devId)) {
            newMarkerData.set(
              _devId,
              Object.assign(Object.assign(prevMarkerData.current.get(_devId), data), {
                markerFlag: markerStatusCode,
              })
            );
          } else {
            newMarkerData.set(_devId, Object.assign(data, { markerFlag: markerStatusCode }));
          }
        });
      }
    } catch (ignore) {}

    if (updateBoundsFlag) {
      if (newMarkerData.size > 0) {
        let bounds;

        newMarkerData.forEach((data) => {
          const lat = data.gpsLat;
          const lng = data.gpsLong;

          if (lat > 0 && lng > 0) {
            if (!bounds) {
              bounds = new window.naver.maps.LatLngBounds(new window.naver.maps.LatLng(lat, lng+0.001));
            } else {
              bounds.extend(new window.naver.maps.LatLng(lat, lng+0.001));
            }
          }
        });
        let margin = { maxZoom: 18 };
        if (bounds) {
          map.fitBounds(bounds, margin);
        }
      }
    }

    setMarkerData(newMarkerData);
  }

  // 작업상황 코드 별 등록된 장비 아이콘 찾기, 없는 경우 empty 전달 //아이콘
  function getWksIcon(value, type) {
    let result = null;

    if (value && type) {
      if (
        ("WKS00010" === value || "WKS00020" === value || "WKS00030" === value) &&
        ("EQU00010" === type ||
          "EQU00020" === type ||
          "EQU00030" === type ||
          "EQU00040" === type ||
          "EQU00050" === type ||
          "EQU00060" === type ||
          "EQU00070" === type ||
          "EQU00080" === type)
      ) {
        result = "/images/" + type + "_" + value + ".png";
      }
    } else if (value) { // 상태만 있는 경우 기본 아이콘 전달
      result = "/images/" + value + ".png";
    }

    return result;
  }

  // 마커 아이콘 생성
  function createMarker(workStIco, devId, gpsLat, gpsLong) {
    let markerOptions = {
      map: map,
      key: devId,
      position: new window.naver.maps.LatLng(gpsLat, gpsLong),
      icon: {
        url: workStIco,
      },
    };
    return new window.naver.maps.Marker(markerOptions);
  }

  // 서비스 변경에 따른 화면 변경 처리
  async function changeSvcView(updateBoundsFlag) {
    callExcavatorList().then((excavatorData) => {
      callDeviceList().then((deviceData) => {
        updateMarkerData(excavatorData, deviceData, updateBoundsFlag);
      });
    });
    callEventList().then();
  }

  function handleMarkerEvent(e) {
    const devId = e.overlay.key;

    if (prevMarkerData.current.has(devId)) {
      let data = prevMarkerData.current.get(devId);

      if (data.marker) {
        // 장비 정보창 html
        let devNm = isEmpty(data.devSn) ? "" : isEmpty(data.devNo) ? data.devSn : data.devSn + "(" + data.devNo + ")";
        let devInfoHtml = [
          '<div style="width: 434px; padding: 35px 45px">' +
            '   <div style="display: flex;">' +
            '       <p style="margin-right:auto; font-weight: bold; font-size: 16px">상태확인</p>' +
            '       <img id="infoCloseBtn" src="/images/close_btn.png" style="margin-left: auto;cursor: pointer" alt="닫기"/>' +
            "   </div>" +
            '   <div style="margin-top: 18px">' +
            '       <ul class="map-marker-nav-fill">' +
            '           <li class="map-marker-nav-item active">' +
            '               <a id="tabBackhoeLink" href="#tabBackhoe" onclick="return false;">장비 운행정보</a>' +
            "           </li>" +
            '           <li class="map-marker-nav-item">' +
            '               <a id="tabDeviceLink" href="#tabDevice" onclick="return false;">디바이스 정보</a>' +
            "           </li>" +
            "       </ul>" +
            "   </div>" +
            '   <div id="tabBackhoe" class="map-marker-nav-tab">' +
            '       <table style="width: 100%; margin-top: 12px">' +
            "           <colgroup>" +
            '               <col style="width: 105px;"/>' +
            '               <col style="width: 239px;"/>' +
            "           </colgroup>" +
            "           <tbody>" +
            "               <tr>" +
            '                   <td style="text-align: left;">장비ID</td>' +
            '                   <td style="text-align: right;">' +
            devNm +
            "</td>" +
            "               </tr>" +
            "               <tr>" +
            '                   <td style="text-align: left;">모델</td>' +
            '                   <td style="text-align: right;">' +
            data.devModel +
            "</td>" +
            "               </tr>" +
            "               <tr>" +
            '                   <td style="text-align: left;">소속</td>' +
            '                   <td style="text-align: right;">' +
            data.devOrg +
            "</td>" +
            "               </tr>" +
            "               <tr>" +
            '                   <td style="text-align: left;">기사</td>' +
            '                   <td style="text-align: right;">' +
            data.user +
            "</td>" +
            "               </tr>" +
            "               <tr>" +
            '                   <td style="text-align: left;">연락처</td>' +
            '                   <td style="text-align: right;">' +
            data.tel +
            "</td>" +
            "               </tr>" +
            "           </tbody>" +
            "       </table>" +
            "   </div>",
          '   <div id="tabDevice" class="map-marker-nav-tab" style="display: none;">' +
            '       <table style="width: 100%; margin-top: 12px">' +
            "           <colgroup>" +
            '               <col style="width: 105px;"/>' +
            '               <col style="width: 239px;"/>' +
            "           </colgroup>" +
            "           <tbody>" +
            "               <tr>" +
            '                   <td style="text-align: left;">디바이스 ID</td>' +
            '                   <td style="text-align: right;">' +
            data.serialNo +
            "</td>" +
            "               </tr>" +
            "               <tr>" +
            '                   <td style="text-align: left;">디바이스 유형</td>' +
            '                   <td style="text-align: right;">' +
            data.devTpNm +
            "</td>" +
            "               </tr>" +
            "               <tr>" +
            '                   <td style="text-align: left;">통신</td>' +
            '                   <td style="text-align: right;">' +
            data.statCdNm +
            "</td>" +
            "               </tr>" +
            "               <tr>" +
            '                   <td style="text-align: left;">CPU 온도</td>' +
            '                   <td style="text-align: right;">' +
            data.cpuTempUnit +
            "</td>" +
            "               </tr>" +
            "               <tr>" +
            '                   <td style="text-align: left;">디바이스 유형</td>' +
            '                   <td style="text-align: right;"><button type="button" id="statusBtn">상태확인</button></td>' +
            "               </tr>" +
            "           </tbody>" +
            "       </table>" +
            "   </div>",
          "</div>",
        ].join("");

        let infowindow = new window.naver.maps.InfoWindow({
          content: devInfoHtml,
          maxWidth: 434,
          backgroundColor: "#FFFFFF",
          borderColor: "#DBDEE3",
          borderWidth: 1,
          disableAnchor: false,
        });

        infowindow.open(map, data.marker);
        let tabBackhoeLink = document.getElementById("tabBackhoeLink");
        let tabDeviceLink = document.getElementById("tabDeviceLink");
        let statusBtn = document.getElementById("statusBtn");

        tabBackhoeLink.addEventListener("click", toggleTab);
        tabDeviceLink.addEventListener("click", toggleTab);

        let infoCloseBtn = document.getElementById("infoCloseBtn");
        infoCloseBtn.addEventListener("click", () => {
          infowindow.close();
        });

        statusBtn.addEventListener("click", () => showStatusModal(devId));

        // statusBtn.addEventListener('click', async (e) => {
        //     // let deviceStatList = await callDeviceStat(devId);
        //     // setMediaData(deviceStatList)
        //     // setStatusModalVisible(true);
        // });
      }
    }
  }

  // 장비 정보창 탭 전환
  function toggleTab(event) {
    const linkParent = event.target.parentElement;
    const linkArr = document.getElementsByClassName("map-marker-nav-item");
    for (let i = 0; i < linkArr.length; i++) {
      if (linkParent === linkArr[i]) {
        linkArr[i].classList.add("active");
      } else {
        linkArr[i].classList.remove("active");
      }
    }

    let id = event.target.hash.replace("#", "");
    let otherTabs = document.getElementsByClassName("map-marker-nav-tab");
    for (let i = 0; i < otherTabs.length; i++) {
      let tab = otherTabs[i];
      if (tab.id === id) {
        tab.style.display = "block";
        tab.parentElement.classList.add("active");
      } else {
        tab.style.display = "none";
        tab.parentElement.classList.remove("active");
      }
    }

    return false;
  }

  // 디바이스 상태 모달 오픈
  function showStatusModal(devId) {
    callDeviceStat(devId).then((deviceStatList) => {
      setStatusMediaData(deviceStatList);
      setStatusModalVisible(true);
    });
  }

  // 이벤트 상황 모달 오픈
  function showEventModal(devId, evtId) {
    callEventActionList(evtId).then((deviceStatList) => {
      setEventMediaData(deviceStatList);
      setEventModalVisible(true);

      // 마커 연동, 이동 및 줌의 smooth를 위해 클릭 트리거 적용
      if (prevMarkerData.current.has(devId)) {
        if (prevMarkerData.current.get(devId).marker) {
          window.naver.maps.Event.trigger(prevMarkerData.current.get(devId).marker, "click");
        }
      }
    });
  }

  // 읽음 처리 체크
  function checkRead() {
    const newTr = document.getElementsByClassName("event-new-tr");

    for (let i = 0; i < newTr.length; i++) {
      const readYn = newTr[i].getAttribute("data-read-yn");
      if (readYn !== "N") {
        newTr[i].classList.remove("event-new-tr");
      }
    }

    if (newTr.length > 0) {
      document.getElementById("map-container").classList.add("event-alert-div");
    } else {
      document.getElementById("map-container").classList.remove("event-alert-div");
    }
  }

  // e: function
  // s: useEffect
  // 초기화
  useEffect(() => {
    callEvtCode(InitCode.EVT).then(); // 이벤트 코드 조회
    callEvtCode(InitCode.DEV).then(); // 디바이스 형태 코드 조회
    callEvtCode(InitCode.DST).then(); // 디바이스 상태 코드 조회
    callSites().then(); // 사이트 조회
    initMap(); // 지도 초기화
  }, []);

  // map 에 데이터가 담기면 지도 초기화 완료
  useEffect(() => {
    if (map) {
      completeInit(InitCode.MAP);
    }
  }, [map]);

  // 사이트 데이터 변경 시
  useEffect(async () => {
    if (!formData.siteId) {
      setFormData({ ...formData, ["svcCd"]: null });
      setServiceData([]);
      return;
    }

    const model = {
      siteId: formData.siteId,
      userId: sessionStorage.getItem("userId"),
    };

    try {
      const response = await apiGetServiceCode(model);

      if (response.data.code === 0) {
        setServiceData(response.data.data);
      } else {
        setServiceData([]);
      }
    } catch (e) {
      setServiceData([]);
    } finally {
      if (!initFlag.get(InitCode.SVC)) {
        completeInit(InitCode.SVC);
        setFormData({ ...formData, ["svcCd"]: defaultValue.svcCd });
      }
    }
  }, [formData.siteId]);

  // 서비스 선택 시 해당 서비스에서 사용하는 장비 받아오기 
  async function getEquiList() {
    const model = {
      siteId: formData.siteId,
      userId: sessionStorage.getItem("userId"),
      catCd: formData.svcCd
    };
    try {
      const response = await apiGetSvcEqui(model);
      if (response.data.code === 0) {
        setSvcEquiList(response.data.data);
      } else {
        setSvcEquiList([]);
      }
    } catch (e) {
      setSvcEquiList([]);
    } 
  }

  // 서비스 선택 시 (새로고침 시 반영 안되는 문제로 initFlag 추가)
  useEffect(async () => {
    if (checkMapUpdateFlag()) {
      if(formData.svcCd != null ) {
        await getEquiList();
      }
      changeSvcView(true).then(() => reset());
    } else {
      stop();
    }
  }, [initFlag, formData.svcCd]);

  // 마커 데이터 수신 시
  useEffect(() => {
    try {
      markerData.forEach((data, devId) => {
        if (data.markerFlag === MarkerStatusCode.DELETE) {
          // 삭제인 경우
          if (prevMarkerData.current.has(devId) && prevMarkerData.current.get(devId).marker) {
            // 이전 설정된 마커가 있는 경우
            // 지도에서 마커 삭제
            prevMarkerData.current.get(devId).marker.setMap(null);
          }
          // 이전 데이터에서 삭제
          prevMarkerData.current.delete(devId);
        } else if (data.markerFlag === MarkerStatusCode.NEW) {
          // 신규인 경우
          if (prevMarkerData.current.has(devId) && prevMarkerData.current.get(devId).marker) {
            // 신규이지만 이전 마커가 있는 경우 (데이터가 꼬인 경우)
            // 지도에서 마커 삭제
            prevMarkerData.current.get(devId).marker.setMap(null);
            // 이전 데이터에서 삭제
            prevMarkerData.current.delete(devId);
          }
          // 신규 마커 생성하여 지도에 등록
          const marker = createMarker(data.workStIco, devId, data.gpsLat, data.gpsLong);
          // 이전 데이터에 추가
          prevMarkerData.current.set(devId, Object.assign(data, { marker: marker }));
        } else if (data.markerFlag === MarkerStatusCode.UPDATE) {
          // 갱신인 경우
          if (prevMarkerData.current.has(devId) && prevMarkerData.current.get(devId).marker) {
            // 이전 마커가 존재하는 경우
            // 마커 정보를 가져와 위경도 좌표·아이콘 갱신
            const marker = prevMarkerData.current.get(devId).marker;
            marker.setPosition(new window.naver.maps.LatLng(data.gpsLat, data.gpsLong));
            if (data.workStIco) {
              marker.setIcon({ url: data.workStIco });
            }
            // 이전 데이터에 반영
            prevMarkerData.current.set(devId, Object.assign(data, { marker: marker }));
          } else {
            // 갱신이지만 마커가 없는 경우 (데이터가 꼬인 경우)
            // 신규 마커 생성하여 지도에 등록
            const marker = createMarker(data.workStIco, devId, data.gpsLat, data.gpsLong);
            prevMarkerData.current.set(devId, Object.assign(data, { marker: marker }));
          }
        }

        if (prevMarkerData.current.has(devId) && prevMarkerData.current.get(devId).marker) {
          window.naver.maps.Event.clearListeners(prevMarkerData.current.get(devId).marker, "click");
          window.naver.maps.Event.addListener(prevMarkerData.current.get(devId).marker, "click", handleMarkerEvent);
        }
      });
    } catch (e) {}
  }, [markerData]);

  // 이벤트 데이터 수신 시
  useEffect(() => {
    if (eventData && eventData.length > 0) {
      let newCnt = 0,
        eventListHtml = "";
      eventData.forEach((item, index) => {
        let dt = moment(item.createDt).format("HH:mm:ss");
        let equSn = isEmpty(item.equSn) ? "" : isEmpty(item.equNo) ? item.equSn : item.equSn + "(" + item.equNo + ")";
        let codeNm = getCodeNm(InitCode.EVT, item.evtTp);
        let evtId = item.evtId;
        let readYn = item.readYn;
        let classNm = "";
        if (readYn === "N") {
          newCnt++;
          classNm = ' class="event-new-tr" ';
        }
        let equId = item.equId;

        eventListHtml +=
          '<tr id="' +
          evtId +
          '" ' +
          classNm +
          ' style="border-bottom: 1px solid #E9ECF1; cursor: pointer; height: 36px" data-read-yn="' +
          readYn +
          '">' +
          '   <td style="width:90px; text-align: left;">' +
          dt +
          "</td>" +
          '   <td style="width:60px; text-align: center;">' +
          equSn +
          "</td>" +
          '   <td style="width:120px; text-align: right;">' +
          codeNm +
          "</td>" +
          "</tr>";
      });
      let eventDataListEl = document.getElementById("eventDataList");
      eventDataListEl.innerHTML = eventListHtml;

      if (newCnt > 0) {
        document.getElementById("map-container").classList.add("event-alert-div");
      }

      // html 등록 후 click 이벤트 추가
      eventData.forEach((item) => {
        let devId = item.aiDevId;
        let evtId = item.evtId;
        const evtIdNode = document.getElementById(item.evtId);
        evtIdNode.addEventListener("click", function () {
          this.classList.remove("event-new-tr");
          checkRead();
          showEventModal(devId, evtId);
        });
      });
    }
  }, [eventData]);

  // MQTT 이벤트 수신 시 이벤트 리스트 즉시 갱신
  useEffect(() => {
    if (!lastEvent || !checkMapUpdateFlag()) {
      return;
    }
    callEventList();
  }, [lastEvent]);

  // MQTT 이벤트 발생 팝업 - 감지 이벤트 리스트와 같은 CustomControl 내 표시
  useEffect(() => {
    const popupEl = document.getElementById("map-mqtt-event-popup");
    if (!popupEl || !map) {
      return undefined;
    }

    if (!eventModalVisible) {
      popupEl.style.display = "none";
      popupEl.innerHTML = "";
      return undefined;
    }

    const receivedAt = lastEvent?.receivedAt;
    popupEl.innerHTML = buildMqttEventPopupHtml(eventInfo, formatElapsedMmSs(receivedAt));
    popupEl.style.display = "block";

    const closeBtn = document.querySelectorAll(".mqttEventPopupCloseBtn");
    closeBtn.forEach(element => {
      element.onclick = closeEventModal;
    });

    const updateElapsed = () => {
      const elapsedEl = document.getElementById("mqttEventElapsedTime");
      if (elapsedEl) {
        elapsedEl.textContent = formatElapsedMmSs(receivedAt);
      }
    };

    updateElapsed();
    const timerId = window.setInterval(updateElapsed, 1000);

    return () => {
      window.clearInterval(timerId);
    };
  }, [map, eventModalVisible, eventInfo, closeEventModal, lastEvent]);
  // e: useEffect

  return (
    <Styles style={{ height: "97%" }}>
      <h1 className='page-tit'>HOME</h1>
      <SearchArea
        leftExtra={
          <Space size={[12, "small"]}>
            <div className={"condition-item"}>
              <label htmlFor={"s1"}>사업장</label>
              <Select
                id={"s1"}
                style={{ width: 148 }}
                placeholder='선택 '
                allowClear
                showArrow={true}
                showSearch={false}
                value={formData.siteId}
                onChange={changeSite}
                options={sitesData.map((values, index) => ({
                  key: index,
                  value: values.siteId,
                  label: values.siteNm,
                }))}
              ></Select>
            </div>
            <div className={"condition-item"}>
              <label htmlFor={"s2"}>서비스</label>
              <Select
                id={"s2"}
                style={{ width: 231 }}
                maxTagCount='responsive'
                allowClear
                showArrow={true}
                showSearch={false}
                placeholder='선택'
                value={formData.svcCd}
                onChange={changeSvc}
              >
                {serviceData.map((values, index) => (
                  <Option key={index} value={values.catCd}>
                    {values.catNm}
                  </Option>
                ))}
              </Select>
            </div>
          </Space>
        }
      />

      <div id={"map-container"}>
        <div id={"map-wrap"} style={{ width: "100%", height: "100%" }}></div>
        <div
          className={`map-event-border-overlay${lastEvent && eventModalVisible ? " map-event-border-overlay--active" : ""}`}
          aria-hidden='true'
        />
      </div>
      <Modal
        title='상태확인'
        visible={isStatusModalVisible}
        onOk={() => setStatusModalVisible(false)}
        onCancel={() => setStatusModalVisible(false)}
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ style: { display: "none" } }}
        getContainer={false}
        width={434}
        centered
        footer={null}
        bodyStyle={{ paddingBottom: "35px" }}
        // 스와이퍼가 있는 모달에서 마우스로 슬라이딩시 터치 미스로 딤처리 영역 클릭시 팝업이 닫혀버리는 현상 방지하기위해 지정 maskClosable
        maskClosable={false}
        className={"eventModal"}
      >
        <PopDeviceStatus mediaData={statusMediaData} />
      </Modal>

      <Modal
        title='이벤트 상황 조회'
        visible={isEventModalVisible}
        onOk={() => setEventModalVisible(false)}
        onCancel={() => setEventModalVisible(false)}
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ style: { display: "none" } }}
        getContainer={false}
        width={434}
        footer={null}
        bodyStyle={{ paddingBottom: "35px" }}
        // 스와이퍼가 있는 모달에서 마우스로 슬라이딩시 터치 미스로 딤처리 영역 클릭시 팝업이 닫혀버리는 현상 방지하기위해 지정 maskClosable
        maskClosable={false}
      >
        <PopEventStatus mediaData={eventMediaData} evtCdData={code.get(InitCode.EVT)} />
      </Modal>
    </Styles>
  );
}

export default Home;
